#@import GliveBooking.Models.Price
#@export GliveBooking.Collections.Prices

class GliveBooking.Collections.Prices extends BookingV2.Collections.Base
  model: GliveBooking.Models.Price

  getCheapest: ->
    @min((price) -> price.getPrice())
